const getInitialFrom = (data, previousSessionValue) => {
	if (!previousSessionValue) {
		return null;
	}

	let previousSessionGateway;

	data.forEach(country =>
		country?.items?.forEach(item => {
			if (
				item?.value?.toUpperCase() === previousSessionValue.value?.toUpperCase()
			) {
				previousSessionGateway = item;
			}
		})
	);

	return previousSessionGateway;
};

export default getInitialFrom;
